import { render, staticRenderFns } from "./FormularioFideicomiso.vue?vue&type=template&id=8722236a&scoped=true"
import script from "./FormularioFideicomiso.vue?vue&type=script&lang=js"
export * from "./FormularioFideicomiso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8722236a",
  null
  
)

export default component.exports